<template>
  <div
    class="menu menu-column menu-fit menu-rounded menu-title-gray-600 menu-icon-gray-400 menu-state-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500 fw-bold fs-3 my-5 mt-lg-2 mb-lg-0"
  >
    <div class="pe-15 h-800px overflow-scroll">
      <div
        class="menu-item menu-accordion"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
      >
        <router-link
          to="/home"
          class="menu-link d-flex justify-content-center align-items-center"
        >
          <span class="menu-icon">
            <i class="bi bi-house-door-fill h3 pt-2"></i>
          </span>
          <span class="menu-title">Accueil</span>
        </router-link>
      </div>
      <AllPermitsMenu :menu-on="menuOn" @menuOnChanged="handleMenuOnChanged" />
      <AllPermitsMenuWithLls
        :menu-on="menuOn"
        @menuOnChanged="handleMenuOnChanged"
      />
      <PermitsMenuWithOrWithoutLls
        :menu-on="menuOn"
        @menuOnChanged="handleMenuOnChanged"
      />
      <PermitsMenuWithLls
        :menu-on="menuOn"
        @menuOnChanged="handleMenuOnChanged"
      />
      <PermitsMenuFavoritesAndPending
        :menu-on="menuOn"
        @menuOnChanged="handleMenuOnChanged"
      />
      <PermitsMenuNotFound
        :menu-on="menuOn"
        @menuOnChanged="handleMenuOnChanged"
      />
      <div
        class="menu-item menu-accordion"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
      >
        <router-link to="/promoters?size=30&page=1" class="menu-link">
          <span class="menu-icon">
            <i class="bi bi-briefcase-fill h3 pt-2"></i>
          </span>
          <span class="menu-title">Promoteurs</span>
        </router-link>
      </div>
      <div
        class="menu-item menu-accordion"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
      >
        <router-link to="/contacts?size=30&page=1" class="menu-link">
          <span class="menu-icon">
            <i class="bi bi-person-fill h3 pt-2"></i>
          </span>
          <span class="menu-title">Contacts</span>
        </router-link>
      </div>
      <CitiesRelated :menu-on="menuOn" @menuOnChanged="handleMenuOnChanged" />
      <div
        class="menu-item menu-accordion"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
      >
        <router-link to="/cities/contacts?size=30&page=1" class="menu-link">
          <span class="menu-icon">
            <i class="bi bi-people-fill h3 pt-2"></i>
          </span>
          <span class="menu-title">Contacts Mairies</span>
        </router-link>
      </div>
      <div v-if="windowWidth <= 1000" class="menu-item menu-accordion">
        <router-link to="/contacts?size=30&page=1" class="menu-link">
          <span class="menu-icon">
            <span class="svg-icon svg-icon-2"
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <rect
                  opacity="0.3"
                  width="12"
                  height="2"
                  rx="1"
                  transform="matrix(-1 0 0 1 15.5 11)"
                  fill="black"
                />
                <path
                  d="M13.6313 11.6927L11.8756 10.2297C11.4054 9.83785 11.3732 9.12683 11.806 8.69401C12.1957 8.3043 12.8216 8.28591 13.2336 8.65206L16.1592 11.2526C16.6067 11.6504 16.6067 12.3496 16.1592 12.7474L13.2336 15.3479C12.8216 15.7141 12.1957 15.6957 11.806 15.306C11.3732 14.8732 11.4054 14.1621 11.8756 13.7703L13.6313 12.3073C13.8232 12.1474 13.8232 11.8526 13.6313 11.6927Z"
                  fill="black"
                />
                <path
                  d="M8 5V6C8 6.55228 8.44772 7 9 7C9.55228 7 10 6.55228 10 6C10 5.44772 10.4477 5 11 5H18C18.5523 5 19 5.44772 19 6V18C19 18.5523 18.5523 19 18 19H11C10.4477 19 10 18.5523 10 18C10 17.4477 9.55228 17 9 17C8.44772 17 8 17.4477 8 18V19C8 20.1046 8.89543 21 10 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H10C8.89543 3 8 3.89543 8 5Z"
                  fill="#C4C4C4"
                /></svg
            ></span>
          </span>
          <span class="menu-title" @click.prevent="disconnectUser()"
            >Déconnexion</span
          >
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import { mapActions, mapGetters } from "vuex";
import AllPermitsMenu from "@/components/menus/AllPermitsMenu";
import AllPermitsMenuWithLls from "@/components/menus/AllPermitsMenuWithLls";
import PermitsMenuWithOrWithoutLls from "@/components/menus/PermitsMenuWithOrWithoutLls";
import PermitsMenuWithLls from "@/components/menus/PermitsMenuWithLls";
import PermitsMenuFavoritesAndPending from "@/components/menus/PermitsMenuFavoritesAndPending";
import PermitsMenuNotFound from "@/components/menus/PermitsMenuNotFound";
import CitiesRelated from "@/components/menus/CitiesRelated";

export default {
  name: "Menu",
  components: {
    AllPermitsMenu,
    AllPermitsMenuWithLls,
    PermitsMenuWithOrWithoutLls,
    PermitsMenuWithLls,
    PermitsMenuFavoritesAndPending,
    PermitsMenuNotFound,
    CitiesRelated,
  },
  data() {
    return {
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    ...mapGetters(["permitsFilter"]),
    ...mapGetters(["menuOn"]),
  },
  mounted() {
    store.commit("permitsFilter", {
      adr_localite_ter: "",
      date_reelle_autorisation__gte: "",
      date_reelle_autorisation__lte: "",
      date_reelle_doc__gte: "",
      date_reelle_doc__lte: "",
      date_reelle_daact__isnull: "",
      date_reelle_doc__isnull: "",
      dep__in: "",
      city__decote_prix_ancien__gt: "",
      city__decote_prix_ancien__lt: "",
      etat_dau: "",
      localite_dem: "",
      nb_lgt_tot_crees__gte: "",
      nb_lgt_tot_crees__lte: "",
      nb_lls__gte: "",
      nb_lls__lte: "",
      nb_lls__gt: "",
      nb_lls__lt: "",
      num_dau: "",
      order: "",
      owner: false,
      referrers: [],
      specific_case: "",
      specific_case__in: "",
      type_dau: "",
    });
  },
  methods: {
    ...mapActions(["disconnect"]),
    disconnectUser() {
      this.disconnect();
    },
    handleMenuOnChanged(newValue) {
      store.commit("menuOn", newValue);
    },
  },
};
</script>
